import React from "react";
import { useAppSelector } from "../hooks";
import { selectToken } from "../states/slices/authReducer";
import { Navigate, useLocation } from "react-router-dom";
import { Store } from "../states/store";

function PrivateRoute({ children }: { children: JSX.Element }): JSX.Element {
  const token = Store.getState().auths.token;
  const location = useLocation();
  if (token === null) {
    return <Navigate to={"/"} state={{ from: location }} replace />;
  }

  return <div>{children}</div>;
}

export default PrivateRoute;
